import { cn } from "@synthesis/shared-utils";

import type { ApplicationDetailField } from "../application-detail-page.lib";
import { DetailFieldRow } from "./detail-field-row";

type DetailSectionProps = {
  title: string;
  fields: ApplicationDetailField[];
  className?: string;
};

export const DetailSection = ({ title, fields, className }: DetailSectionProps) => (
  <section className={cn("flex flex-col", className)}>
    <h2 className="subtitle-lg text-type-common mb-4">{title}</h2>
    <div className="flex flex-col">
      {fields.map((field, fieldIndex) =>
        field.fullWidth ? (
          <div key={`${field.label || "full"}-${fieldIndex}`} className="border-neutrals-90 border-b py-3 last:border-b-0">
            {field.value}
          </div>
        ) : (
          <DetailFieldRow key={`${field.label ?? "field"}-${fieldIndex}`} label={field.label}>
            {field.value}
          </DetailFieldRow>
        ),
      )}
    </div>
  </section>
);
